var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { ref: "dropdown", staticClass: "theme-notifications" }, [
    _c(
      "a",
      {
        staticClass: "theme-notifications__toggler hidden md:block",
        attrs: { href: "#" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.toggleDropdown.apply(null, arguments)
          }
        }
      },
      [
        _c("i", { staticClass: "icon-notification" }),
        _vm._v(" "),
        _vm.hasUnread
          ? _c("i", { staticClass: "theme-notifications__cirlce" })
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "theme-notifications__toggler md:hidden",
        attrs: {
          "data-feature": "open-modal",
          "data-target": "notifications-modal"
        }
      },
      [
        _c("i", { staticClass: "icon-notification" }),
        _vm._v(" "),
        _vm.hasUnread
          ? _c("i", { staticClass: "theme-notifications__cirlce" })
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "theme-notifications__container" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasUnread,
              expression: "hasUnread"
            }
          ],
          staticClass: "theme-notifications__upper"
        },
        [
          _c("div", { staticClass: "theme-notifications__title-wrapper" }, [
            _c("h3", { staticClass: "theme-notifications__title" }, [
              _vm._v("Notifications")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-[#7B7C85]" }, [
              _vm._v("(" + _vm._s(_vm.notifications.length) + ")")
            ])
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "theme-btn theme-btn--text",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.markAllRead.apply(null, arguments)
                }
              }
            },
            [_vm._v("Mark all as read")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "theme-notifications__list",
          class: { bordered: _vm.total > 0 }
        },
        [
          _vm._l(_vm.notifications, function(notification) {
            return _c("notification", {
              key: notification.id,
              attrs: { notification: notification },
              on: {
                read: function($event) {
                  return _vm.markAsRead(notification)
                }
              }
            })
          }),
          _vm._v(" "),
          !_vm.hasUnread
            ? _c("li", { staticClass: "theme-notifications__empty-result" }, [
                _vm._v(
                  "\n        You don't have any unread notifications.\n      "
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasUnread
        ? _c("div", { staticClass: "theme-notifications__footer" }, [
            _c(
              "a",
              {
                staticClass:
                  "theme-btn theme-btn--tertiary theme-btn--small theme-btn--block",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.fetch(null)
                  }
                }
              },
              [
                _vm._v("\n        View All\n        "),
                _c("span", { staticClass: "icon-go-right" })
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal modal--bottom",
        attrs: { "data-feature": "modal", "data-name": "notifications-modal" }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal__content",
            attrs: { "data-feature": "modal-active-area" }
          },
          [
            _c(
              "button",
              {
                staticClass: "modal__close",
                attrs: {
                  "data-feature": "close-modal",
                  "data-target": "notifications-modal"
                }
              },
              [_c("i", { staticClass: "icon-close" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasUnread,
                    expression: "hasUnread"
                  }
                ],
                staticClass: "theme-notifications__upper"
              },
              [
                _c(
                  "div",
                  { staticClass: "theme-notifications__title-wrapper" },
                  [
                    _c("h3", { staticClass: "theme-notifications__title" }, [
                      _vm._v("Notifications")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-[#7B7C85]" }, [
                      _vm._v("(" + _vm._s(_vm.notifications.length) + ")")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "theme-btn theme-btn--tertiary theme-btn--small px-0 hover:bg-transparent",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.markAllRead.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Mark all as read")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "theme-notifications__list",
                class: { bordered: _vm.total > 0 }
              },
              [
                _vm._l(_vm.notifications, function(notification) {
                  return _c("notification", {
                    key: notification.id,
                    attrs: { notification: notification },
                    on: {
                      read: function($event) {
                        return _vm.markAsRead(notification)
                      }
                    }
                  })
                }),
                _vm._v(" "),
                !_vm.hasUnread
                  ? _c(
                      "li",
                      { staticClass: "theme-notifications__empty-result" },
                      [
                        _vm._v(
                          "\n          You don't have any unread notifications.\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.hasUnread
              ? _c("div", { staticClass: "theme-notifications__footer" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "theme-btn theme-btn--tertiary theme-btn--small theme-btn--block",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.fetch(null)
                        }
                      }
                    },
                    [
                      _vm._v("\n          View All\n          "),
                      _c("span", { staticClass: "icon-go-right" })
                    ]
                  )
                ])
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c2c806c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c2c806c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeNotifications.vue
// module id = 635
// module chunks = 1